import AssignmentRoundedIcon from '@material-ui/icons/AssignmentRounded';
import React from 'react';
import styled, { css } from 'styled-components/macro';
import {
  fontSize,
  fontWeight,
  layout,
  lineHeight,
  media,
  neutral,
  radius,
  shadow,
  space,
} from '../../../theme/tokens';
import { QuestionBullet } from '../../common/elements/Assessments';
import * as CommonCards from '../../common/elements/Cards';
import { StaffFilterLink, StaffHeader } from '../../staff/elements/User';

// the "no learning plan yet" card is rendered on its own, so give it the page gutter
export const CardWithImage = styled(CommonCards.CardWithImage)`
  justify-content: space-between;
  margin: ${space[4]} ${layout.gutter};

  ${media.md`
    max-width: ${layout.readableMaxWidth};
    margin: ${space[6]} auto;
  `}
`;

export const AssessmentForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space[4]};
  width: 100%;
  padding: ${space[5]} ${layout.gutter} ${space[7]};

  ${media.md`
    padding: ${space[6]} ${layout.gutterWide} ${space[7]};
  `}
`;

export const AssessmentLink = styled(StaffFilterLink)`
  margin: 0;
`;

export const AssessmentHeader = styled(StaffHeader)`
  margin: 0;
  text-align: center;
`;

export const AnswerList = styled.ol`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
  width: 100%;
  max-width: ${layout.readableMaxWidth};
  margin: ${space[2]} 0;
  padding: 0;
  list-style-type: none;
`;

export const AnswerLi = styled.li`
  display: flex;
  flex-direction: column;
  gap: ${space[2]};
  margin: 0;
  padding: ${space[4]};
  border-radius: ${radius.lg};
  box-shadow: ${shadow.sm};
  background-color: ${({ theme }) => theme.pendingDark};
  ${({ isComplete }) =>
    isComplete &&
    css`
      background-color: ${({ theme }) => theme.targetHighlight};
    `};
`;

export const StudentBullet = styled(QuestionBullet)`
  grid-area: bullet;
  background: ${({ theme }) => theme.buttonWarningGradient};
`;

export const StudentQuestion = styled(StaffHeader).attrs({ as: 'label' })`
  grid-area: question;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${space[3]};
  font-size: ${fontSize.lg};
  font-weight: ${fontWeight.bold};
  line-height: ${lineHeight.tight};
  color: ${({ theme, isComplete }) =>
    isComplete
      ? theme.isTargetDark
        ? theme.textLight
        : theme.textDark
      : theme.textLight};

  ${media.md`
    font-size: ${fontSize.lg};
  `}
`;

export const SaveStatus = styled.p`
  margin: 0;
  font-size: ${fontSize.sm};
  font-weight: ${fontWeight.semibold};
  color: ${({ $isError, theme }) =>
    $isError ? theme.errorMessage : neutral.textMuted};
`;

export const InfoHeader = styled.h2`
  margin: 0;
  font-weight: ${fontWeight.semibold};
  font-size: ${fontSize.xl};
  line-height: ${lineHeight.tight};
`;

export const NoAssessmentIcon = (props) => {
  return <AssignmentRoundedIcon style={{ fontSize: '5rem' }} {...props} />;
};

export * from '../../common/elements/Assessments';
export * from '../../common/elements/Cards';
export * from '../../common/elements/Form';
export * from '../../common/elements/Notifications';
export * from '../../common/elements/Staff';
